/* WAD Noir — theme scripts (no dependencies) */
(function () {
  'use strict';
  var T = window.theme || {};
  function L(k, d) { var s = window.theme && window.theme.strings; return (s && s[k]) || d; }
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  function formatMoney(cents) {
    var fmt = T.moneyFormat || '${{amount}}';
    var n = (cents / 100);
    var withDelims = function (num, dec, th, d) {
      var parts = num.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return parts.join(d);
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return withDelims(n, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(n, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(n, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelims(n, 2, "'", '.');
        default: return withDelims(n, 2, ',', '.');
      }
    });
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }

  /* Size reminder styles (red + shake) */
  (function () {
    var st = document.createElement('style');
    st.textContent = '.opt.is-missing legend{color:#e5484d}' +
      '.opt.is-missing .opt__values label{border-color:#e5484d!important;box-shadow:0 0 0 1px #e5484d;background:rgba(229,72,77,.14)}' +
      '.wad-shake{animation:wadshake .4s}@keyframes wadshake{0%,100%{transform:translateX(0)}25%{transform:translateX(-6px)}75%{transform:translateX(6px)}}' +
      '.form-msg.is-error{display:block;background:#e5484d;color:#fff;padding:10px 12px;border-radius:8px;font-size:14px;font-weight:600;text-align:center;margin-top:10px}' +
      '.form-msg.is-ok{display:block;background:#1f9d55;color:#fff;padding:10px 12px;border-radius:8px;font-size:14px;font-weight:600;text-align:center;margin-top:10px}';
    document.head.appendChild(st);
  })();
  var LANG = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
  var TXT = ({
    fr: { choose: 'Choisir la taille', pick: 'Choisis ta taille avant d’ajouter au panier.', added: 'Ajouté au panier ✓' },
    es: { choose: 'Elegir talla', pick: 'Elige tu talla antes de añadir a la bolsa.', added: 'Añadido a la bolsa ✓' }
  })[LANG] || { choose: 'Choose size', pick: 'Please choose a size first.', added: 'Added to your bag ✓' };

  /* Announcement rotator */
  $$('[data-rotator]').forEach(function (bar) {
    var msgs = $$('.announce__msg', bar); if (msgs.length < 2) return;
    var i = 0;
    setInterval(function () { msgs[i].classList.remove('is-active'); i = (i + 1) % msgs.length; msgs[i].classList.add('is-active'); }, 4500);
  });

  /* Header scroll state */
  var header = $('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 10); };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }

  /* Drawers */
  var lastFocus = null;
  function openPanel(el) { if (!el) return; lastFocus = document.activeElement; el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; var f = el.querySelector('button, a, input'); if (f) setTimeout(function () { f.focus(); }, 50); }
  function closePanel(el) { if (!el) return; el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; if (lastFocus) lastFocus.focus(); }
  var menu = $('#MenuDrawer'), cartDrawer = $('#CartDrawer');
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-open-menu]')) { openPanel(menu); }
    else if (t.closest('[data-close-menu]')) { closePanel(menu); }
    else if (t.closest('[data-close-drawer]')) { closePanel(cartDrawer); }
    else if (t.closest('[data-open-cart]') && T.cartType === 'drawer' && cartDrawer) { e.preventDefault(); refreshCart().then(function () { openPanel(cartDrawer); }); }
    else if (t.closest('[data-open-search]')) { var o = $('[data-search-overlay]'); if (o) { o.hidden = false; $('input[type=search]', o).focus(); } }
    else if (t.closest('[data-close-search]')) { var o2 = $('[data-search-overlay]'); if (o2) o2.hidden = true; }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (menu && menu.classList.contains('is-open')) closePanel(menu);
    if (cartDrawer && cartDrawer.classList.contains('is-open')) closePanel(cartDrawer);
    var o = $('[data-search-overlay]'); if (o) o.hidden = true;
  });

  /* Cart */
  function updateCount(count) { $$('[data-cart-count]').forEach(function (c) { c.textContent = count; c.classList.toggle('is-empty', count === 0); }); }
  function renderCart(cart) {
    var body = $('[data-cart-items]'); if (!body) return;
    updateCount(cart.item_count);
    $$('[data-cart-subtotal]').forEach(function (s) { s.textContent = formatMoney(cart.total_price); });
    if (!cart.items.length) { body.innerHTML = '<p class="drawer__empty">' + esc(L('cartEmpty', 'Your cart is empty.')) + '</p>'; return; }
    body.innerHTML = cart.items.map(function (item, idx) {
      var img = item.image ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') + '" alt="' + esc(item.product_title) + '" loading="lazy">' : '';
      var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<span class="line__variant">' + esc(item.variant_title) + '</span>' : '';
      return '<div class="line" data-line="' + (idx + 1) + '">' +
        '<a class="line__img" href="' + item.url + '">' + img + '</a>' +
        '<div><a class="line__title" href="' + item.url + '">' + esc(item.product_title) + '</a>' + variant +
        '<div class="line__qty"><button type="button" data-line-change="-1" aria-label="Decrease">&minus;</button><span>' + item.quantity + '</span><button type="button" data-line-change="1" aria-label="Increase">+</button></div>' +
        '<button type="button" class="line__remove" data-line-remove>' + esc(L('remove', 'Remove')) + '</button></div>' +
        '<div class="line__price">' + formatMoney(item.final_line_price) + '</div></div>';
    }).join('');
  }
  function refreshCart() {
    return fetch((T.routes ? T.routes.cart : '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); }).then(function (cart) { renderCart(cart); return cart; });
  }
  function changeLine(line, qty) {
    return fetch(T.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: line, quantity: qty }) })
      .then(function (r) { return r.json(); }).then(renderCart);
  }
  if (cartDrawer) {
    cartDrawer.addEventListener('click', function (e) {
      var line = e.target.closest('[data-line]'); if (!line) return;
      var n = parseInt(line.getAttribute('data-line'), 10);
      var cur = parseInt($('.line__qty span', line).textContent, 10);
      var ch = e.target.closest('[data-line-change]');
      if (ch) changeLine(n, Math.max(0, cur + parseInt(ch.getAttribute('data-line-change'), 10)));
      if (e.target.closest('[data-line-remove]')) changeLine(n, 0);
    });
  }

  /* AJAX add to cart */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.js-product-form');
    if (!form || T.cartType !== 'drawer' || !window.fetch) return;
    e.preventDefault();
    var btn = form.querySelector('[type=submit]');
    var err = form.querySelector('[data-form-error]');
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }
    fetch(T.routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(form) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { if (err) { err.textContent = TXT.added; err.className = 'form-msg is-ok'; err.hidden = false; setTimeout(function () { err.hidden = true; }, 3500); } return refreshCart(); })
      .then(function () { openPanel(cartDrawer); })
      .catch(function (j) { if (err) { err.textContent = (j && (j.description || j.message)) || L('addError', 'Could not add to cart.'); err.className = 'form-msg is-error'; err.hidden = false; } })
      .finally(function () { if (btn) { btn.removeAttribute('aria-busy'); btn.disabled = false; } });
  });

  /* Product page */
  $$('[data-product-section]').forEach(function (sec) {
    var jsonEl = $('[data-product-json]', sec); if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var form = $('.product-form', sec);
    var idInput = $('[data-variant-id]', sec);
    var mainMedia = $('[data-main-media]', sec);
    var SIZE_RE = /size|taille|talla|tama/i;
    var sizeSets = $$('.opt', sec).filter(function (fs) { var lg = $('legend', fs); return lg && SIZE_RE.test(lg.textContent) && $$('input', fs).length > 1; });

    function setImage(src, mediaId) {
      if (!mainMedia || !src) return;
      var img = $('img', mainMedia);
      if (img) { img.removeAttribute('srcset'); img.src = src; }
      $$('[data-thumb]', sec).forEach(function (t) { t.classList.toggle('is-active', String(t.getAttribute('data-media-id')) === String(mediaId)); });
    }
    $$('[data-thumb]', sec).forEach(function (t) { t.addEventListener('click', function () { setImage(t.getAttribute('data-src'), t.getAttribute('data-media-id')); }); });

    function selected() { return $$('.opt', sec).map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; }); }
    function findVariant(opts) { return product.variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); }); }
    function findLoose(opts, needAvail) { return product.variants.find(function (v) { return (!needAvail || v.available) && v.options.every(function (o, i) { return opts[i] == null || o === opts[i]; }); }); }
    function markAvailability(opts) {
      $$('.opt', sec).forEach(function (fs, idx) {
        $$('input', fs).forEach(function (inp) {
          var test = opts.slice(); test[idx] = inp.value;
          var v = findLoose(test, true);
          var lbl = inp.nextElementSibling;
          if (lbl) lbl.classList.toggle('is-unavailable', !v);
        });
      });
    }
    function update() {
      var opts = selected();
      $$('.opt', sec).forEach(function (fs, i) { var l = $('[data-option-label]', fs); if (l) l.textContent = opts[i] || (sizeSets.indexOf(fs) > -1 ? TXT.choose : ''); if (opts[i] != null) fs.classList.remove('is-missing'); });
      markAvailability(opts);
      var btn = $('[data-add-btn]', sec);
      var err = $('[data-form-error]', sec);
      if (err && err.classList.contains('is-error') && !sizeSets.some(function (fs) { return !$('input:checked', fs); })) err.hidden = true;
      if (opts.some(function (o) { return o == null; })) {
        var pv = findLoose(opts, false);
        if (pv && pv.featured_media && pv.featured_media.preview_image) setImage(pv.featured_media.preview_image.src, pv.featured_media.id);
        if (btn) { var anyAvail = !!findLoose(opts, true); btn.disabled = !anyAvail; btn.textContent = anyAvail ? L('addToCart', 'Add to cart') : L('soldOut', 'Sold out'); }
        return;
      }
      var v = findVariant(opts);
      if (!v) { if (btn) { btn.disabled = true; btn.textContent = L('unavailable', 'Unavailable'); } return; }
      if (idInput) idInput.value = v.id;
      if (btn) { btn.disabled = !v.available; btn.textContent = v.available ? L('addToCart', 'Add to cart') : L('soldOut', 'Sold out'); }
      var priceWrap = $('[data-price] .price', sec);
      if (priceWrap) {
        var sale = v.compare_at_price && v.compare_at_price > v.price;
        priceWrap.classList.toggle('price--sale', !!sale);
        priceWrap.innerHTML = (sale ? '<s class="price__compare">' + formatMoney(v.compare_at_price) + '</s>' : '') + '<span class="price__current">' + formatMoney(v.price) + '</span>';
      }
      if (v.featured_media && v.featured_media.preview_image) { setImage(v.featured_media.preview_image.src, v.featured_media.id); }
      if (window.history.replaceState) { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString()); }
    }

    /* Customer must pick a size (no size pre-selected) */
    function missingSizes() { return sizeSets.filter(function (fs) { return !$('input:checked', fs); }); }
    function warnSize(e) {
      var miss = missingSizes(); if (!miss.length) return false;
      if (e) { e.preventDefault(); e.stopPropagation(); if (e.stopImmediatePropagation) e.stopImmediatePropagation(); }
      miss.forEach(function (fs) { fs.classList.add('is-missing'); fs.classList.remove('wad-shake'); void fs.offsetWidth; fs.classList.add('wad-shake'); });
      var err = $('[data-form-error]', sec);
      if (err) { err.textContent = TXT.pick; err.className = 'form-msg is-error'; err.hidden = false; }
      try { miss[0].scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (x) {}
      return true;
    }
    if (form && sizeSets.length) {
      if (!/[?&]variant=/.test(window.location.search)) {
        sizeSets.forEach(function (fs) { $$('input', fs).forEach(function (i) { i.checked = false; }); });
      }
      form.addEventListener('submit', function (e) { warnSize(e); }, true);
      var dyn = $('.product__dynamic', sec);
      if (dyn) dyn.addEventListener('click', function (e) { warnSize(e); }, true);
      update();
    }

    if (form) { form.addEventListener('change', function (e) { if (e.target.matches('.opt input')) update(); }); if ($('.opt', sec)) markAvailability(selected()); }

    $$('[data-qty]', sec).forEach(function (q) {
      var input = $('input', q);
      $('[data-qty-minus]', q).addEventListener('click', function () { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); });
      $('[data-qty-plus]', q).addEventListener('click', function () { input.value = (parseInt(input.value, 10) || 1) + 1; });
    });
  });

  /* Product recommendations */
  $$('[data-recs]').forEach(function (el) {
    if (el.children.length) return;
    var io = new IntersectionObserver(function (entries, obs) {
      if (!entries[0].isIntersecting) return; obs.disconnect();
      fetch(el.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
        var d = document.createElement('div'); d.innerHTML = html;
        var inner = d.querySelector('[data-recs]'); if (inner && inner.innerHTML.trim()) el.innerHTML = inner.innerHTML;
      });
    }, { rootMargin: '0px 0px 400px 0px' });
    io.observe(el);
  });

  /* Collection filters auto-submit */
  $$('[data-filter-form]').forEach(function (f) {
    f.addEventListener('change', function (e) { if (e.target.matches('[data-auto-submit]')) f.submit(); });
  });

  /* Reveal flip tiles */
  var flips = $$('.flip');
  if (flips.length && 'IntersectionObserver' in window) {
    var fo = new IntersectionObserver(function (entries) { entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-visible'); fo.unobserve(en.target); } }); }, { threshold: .3 });
    flips.forEach(function (f) { fo.observe(f); });
  } else { flips.forEach(function (f) { f.classList.add('is-visible'); }); }


  /* Keep drawer count in sync on load (bfcache) */
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCart(); });
})();
